import * as modal from "../util/modal.ts";
import * as amplify from "../util/amplify.ts";
import ApiServer from "../ApiServer.js";

import { FilerTreeCache } from "../server/objects/FilerBeans.js"
import { newMultiBar } from "../util/progressbarmulti.js"
import { registerFileDropConsumer, registerDragStart } from "../lib/FileUtils.ts";


registerDragStart(".filer-file",async function(ev,dropPromiseBuilder){
  var 
    movingFile = FilerTreeCache.get($(this).metaId()),
    potentialDrop = Array.from(document.querySelectorAll('.filer-folder'));
    
  potentialDrop = potentialDrop.filter(node=>node.getAttribute('data-fw-meta-id')!==movingFile.parentFolderId)  
  
  var  
    dropEvent = await dropPromiseBuilder(this,potentialDrop);
  
  movingFile.parentFolderId = $(dropEvent.target).metaId()
  ApiServer.filerputfile(movingFile).then(()=>{
    modal.toastDone('files.toastfilemoved',movingFile)  
  })
  amplify.publish('filerNeedRefresh');

  
});


registerFileDropConsumer(function factory(){
  return {nodes:document.querySelectorAll('.filer-folder'),ondrop(event){
    var metaId = $(event.target).metaId();
    if(metaId){
      upload(metaId,event.dataTransfer.files)
    }
  }}
  
})

//import('./modal_progress.mustache').then(tpl=>modal.openModal(tpl,{}))
export async function upload(parentFolderId,files){
  try{
    var ProgressBar = newMultiBar(files.length);
    for(var i=0;i<files.length;i++){
      var 
        file = files[i],
        subProgressBar = ProgressBar.subProgress();
      await ApiServer.filerputfile.setOptions({progressbar:subProgressBar})({
        parentFolderId,
        file
      },()=>{},function(err){
        if(err.code==='611'){
          modal.oops('fw2.apierrors.611file')
        }else{
          modal.oops('fw2.defaultError')
        }
        
      })
    }
  } finally{
    ProgressBar.close()
    amplify.publish('filerNeedRefresh')
    if(i>0){
      modal.toastDone('files.toastfileuploaded',i)
    }
  }
  
}
